import { ImageDto } from './imageDto';

export class ImagesDto {
  public id!: string;
  public images: ImageDto[] = [];
}
